import React from "react";
import logo from "./logo.png";
import { Sparkles } from "lucide-react";

const CommonLoader = () => {
  return (
    <div className="fixed inset-0 bg-[#041a0f]/95 backdrop-blur-md z-[9999] flex flex-col items-center justify-center transition-all duration-300 font-sans select-none">
      
      {/* Soft Ambient Light Glow Blobs */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[350px] h-[350px] bg-gradient-to-tr from-gold-900/20 via-[#0b3a24]/30 to-transparent rounded-full filter blur-[100px] pointer-events-none"></div>

      <div className="relative flex items-center justify-center">
        {/* Outer glowing spinning gold ring */}
        <div className="absolute w-28 h-28 rounded-full border-2 border-transparent border-t-[#eddca6] border-r-[#c5a85a] animate-spin shadow-[0_0_15px_rgba(237,220,166,0.3)]"></div>
        
        {/* Inner reverse spinning emerald & gold ring */}
        <div className="absolute w-22 h-22 rounded-full border-2 border-transparent border-b-[#eddca6]/70 border-l-[#0b3a24] animate-spin [animation-direction:reverse]"></div>
        
        {/* Center Logo Icon */}
        <div className="w-16 h-16 bg-gradient-to-br from-[#092e1d] to-[#041a0f] rounded-full border border-[#eddca6]/40 flex items-center justify-center shadow-2xl relative z-10">
          <img 
            src={logo} 
            alt="Chirayil Logo" 
            className="w-10 h-10 object-contain brightness-0 invert filter drop-shadow-[0_0_8px_rgba(237,220,166,0.5)] animate-pulse" 
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      </div>
      
      {/* Loading Brand Text */}
      <div className="mt-8 text-center space-y-1.5 z-10">
        <div className="flex items-center justify-center gap-1.5">
          <Sparkles className="w-3.5 h-3.5 text-[#eddca6] animate-pulse" />
          <h2 className="text-base font-serif font-black text-[#eddca6] tracking-widest uppercase">
            CHIRAYIL
          </h2>
          <Sparkles className="w-3.5 h-3.5 text-[#eddca6] animate-pulse" />
        </div>
        <p className="text-[9px] uppercase tracking-[0.25em] font-medium text-white/70">
          Gold & Diamonds
        </p>
        <p className="text-xs font-medium text-[#eddca6]/80 tracking-wider animate-pulse pt-2 font-sans">
          Loading secure experience...
        </p>
      </div>

    </div>
  );
};

export default CommonLoader;
